// src/components/common/FlashMessage.tsx
import React from "react";
import Snackbar from "@mui/material/Snackbar";

interface FlashMessageProps {
  open: boolean;
  message: string;
  severity?: "success" | "info" | "warning" | "error";
  onClose: () => void;
}

const FlashMessage: React.FC<FlashMessageProps> = ({ open, message, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000} // ✅ fades away after 3s
      onClose={onClose}
      message={message}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }} // ✅ bottom-left corner
      sx={{
        "& .MuiSnackbarContent-root": {
          backgroundColor: "#18bf1289", // gray background
          color: "#0a0a0aff",              // white text
          fontWeight: 500,
          borderRadius: 4,
          boxShadow: 3,
        },
      }}
    />
  );
};

export default FlashMessage;